import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../App/Util/axiosErrorHandler'
import { TErrorDescriptor } from '../../../ErrorHandling/store'

type TAppointmentDeleteReturn = TErrorDescriptor & {
  appointmentUuid: string
  appointmentDateKey: string
}

type TAppointmentDelete = {
  appointmentUuid: string
  appointmentDateKey: string
  isDeleteFutureAppointments: boolean
}

export const appointmentDelete = createAsyncThunk<
  TAppointmentDeleteReturn,
  TAppointmentDelete,
  IThunkReject<any>
>('appointment/delete', async (payload, { rejectWithValue }) => {
  const { appointmentUuid, isDeleteFutureAppointments, appointmentDateKey } =
    payload
  let apiData: null | TAppointmentDeleteReturn = null

  try {
    const promise = clientSDK
      .instance()
      .delete(
        `calendar/appointments/${appointmentUuid}?is_delete_future_appointments=${isDeleteFutureAppointments}`,
      )
    const result = await promise

    apiData = {
      appointmentUuid,
      appointmentDateKey,
      title: 'Appointment has been deleted.',
      type: 'info',
      icon: 'check',
    }
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData
})
